/**
 {op}	required	Weather map layer. Full list of available weather map layers here
 https://openweathermap.org/api/weather-map-2#layers
 {z}	required	Number of zoom level
 {x}	required	Number of x tile coordinate
 {y}	required	Number of y tile coordinate
 */

/**
 * Weather maps 2
 return ['http://maps.openweathermap.org/maps/2.0/weather/',
 'CL', '/', zoom, '/', coord.x, '/', coord.y, '?appid=', apiKey].join('');
 */

/**
 * Creates a weather layer. Version 1.0!
 * @param map
 * @param key
 * @param apiKey
 */
export const createWeatherLayer = (
  map: google.maps.Map,
  key: string,
  apiKey: string
): google.maps.ImageMapType => {
  const radar = new google.maps.ImageMapType({
    getTileUrl: function (coord: google.maps.Point, zoom: number) {
      return [
        'https://tile.openweathermap.org/map/',
        key,
        '/',
        zoom,
        '/',
        coord.x,
        '/',
        coord.y,
        '?appid=',
        apiKey
      ].join('')
    },
    tileSize: new google.maps.Size(256, 256)
  })
  return radar
}

/**
 * Open weather layer 2.0
 * {Op}	Meaning	Units
 * PAC0	Convective precipitation	mm
 * PR0	Precipitation intensity	mm/s
 * PARAIN	Accumulated precipitation - rain	mm
 * PASNOW	Accumulated precipitation - snow	mm
 * SD0	Depth of snow	m
 * WS10UV	Wind speed at an altitude of 10 meters	m/s
 * WNDUV	Joint display of speed wind (color) and wind direction (arrows), received by U and V components	m/s
 * APM	Atmospheric pressure on mean sea level	hPa
 * TA2	Air temperature at a height of 2 meters	°C
 * TD2	Temperature of a dew point	°C
 * TS0	Soil temperature 0-10 сm	K
 * TS10	Soil temperature >10 сm	K
 * HRD0	Relative humidity	%
 * CL	Cloudiness	%
 * */

export const createWeatherLayer2 = (map: google.maps.Map, key: string, apiKey: string) => {
  const radar = new google.maps.ImageMapType({
    getTileUrl: function (coord: google.maps.Point, zoom: number) {
      return [
        'https://maps.openweathermap.org/maps/2.0/weather/1h/',
        key,
        '/',
        zoom,
        '/',
        coord.x,
        '/',
        coord.y,
        '?appid=',
        apiKey
      ].join('')
    },
    tileSize: new google.maps.Size(256, 256)
  })
  return radar
}
